import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="faq" style={{
    paddingTop: "30px",
    paddingBottom: "30px"
  }} data-id="element-54" data-mp="1bmln38v77zl0">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-55" data-mp="248o7oirdyf2e">
        <h2 id="faq" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-56" data-mp="1ujedmxczembn">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-10 divide-y divide-ink-800 border-y border-ink-800" data-id="element-57" data-mp="2n5z6615714gs">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-58" data-mp="14w3jr23c9sm3" data-mpi={index}>
                <h3 data-id="element-59" data-mp="14sxtvkmvympb">
                  <button onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-smooth hover:text-gold" style={{
                paddingTop: "10px",
                paddingBottom: "10px"
              }} data-id="element-60" data-mp="10tytmdc3ne47">
                    <span className="font-display text-base font-700 text-white sm:text-lg" data-id="element-61" data-mp="1oldxwbnfs5i3">
                      {faq.question}
                    </span>
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full border border-ink-600 text-gold" data-id="element-62" data-mp="1xiwnltc0z80b">
                      {isOpen ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-63" data-mp="1sj1ztynjqyjh" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-64" data-mp="36q2o2tbxcut" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-65" data-mp="1y9391sbhbpyq">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-66" data-mp="1yao55mdfzgyp">
                      <p className="pb-6 pr-10 text-[15px] leading-relaxed text-slate-300" data-id="element-67" data-mp="2m6sf6rmz7nam">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}